import * as actions from './redux/actions';

import React, { Component } from 'react';

import KuposModal from './KuposModal';
import PropTypes from 'prop-types';
import SvgHome from './SvgHome';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class AddCardInfoModal extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  render() {
    return (
      <div className="common-add-card-info-modal">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div
            className="bip-info-modal-container"

            // style={{padding: '10p'}}
          >
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>
            <div style={{ marginTop: 15 }}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img style={{ width: 80 }} src={this.props.icon} />
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: 20,
                }}
              >
                <span className="bold-text" style={{ fontSize: 15, textAlign: 'center' }}>
                  {this.props.t('TRANSLATIONS.CARD_ADD_INFO_TITLE')}
                </span>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: 10,
                }}
              >
                <span style={{ textAlign: 'center', fontSize: 14 }}>
                  {this.props.t('TRANSLATIONS.CARD_ADD_INFO')}
                </span>
              </div>

              <div className="login-signup-button font12">
                <button
                  className="kupos-button"
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.addCard();
                  }}
                >
                  {this.state.loading ? (
                    <div className="loader-cricle"></div>
                  ) : (
                    <span>{this.props.t('CANCEL_TICKET.OK_ACCEPT')}</span>
                  )}
                </button>

                <button
                  className="kupos-button kupos-button2"
                  onClick={this.props.onHide}
                  style={{ marginTop: 10, textAlign: 'center' }}
                >
                  <span>{this.props.t('CANCEL_TICKET.NO_GO_BACK')}</span>
                </button>
              </div>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCardInfoModal);



// WEBPACK FOOTER //
// ./src/features/common/AddCardInfoModal.js